import React from 'react';
import ChatWidget from './components/ChatWidget/ChatWidget';
import './App.css';

function App() {
  return (
    <div className="App">
      <div style={{ padding: '20px' }}>
        <h1>Welcome to our store</h1>
        <p>This is a demo page. The chat widget is in the bottom right corner.</p>
      </div>
      <ChatWidget 
        allowImageUpload={false}  // Set to true to enable image upload
        allowMultilineInput={false} // Set to true to enable multiline input
        language="zhTW" // Change to "en" for English
      />
    </div>
  );
}

export default App;
